const React = require('react');
const IconButton = require('@material-ui/core/IconButton').default;
const CloseIcon = require('../../../icons/Close');
const Slot = require('./Slot');


module.exports = (props) => {
  return (
    <Slot
      disabled={props.disabled}
      onClick={props.onClick}
    >
      <div className="layoutRow fhaC fvaC wmax pl30 pr15">
        <div
          className="mr5 tl f12 fw3 lh110% lts0em ov ws tov"
        >{props.name || 'file'}</div>
        <IconButton
          className="rlv*2 c0*2 z1"
          onClick={props.onRemove}
        >
          <CloseIcon className="w14 c0 dn o50 o100<2:h"/>
        </IconButton>
      </div>
    </Slot>
  );
};
